/**
 * MFA Settings Tab Component
 */
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Mail, Lock } from "lucide-react";

export const MFATab = ({ settings, setSettings }) => {
  return (
    <Card className="border-amber-200">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-100 rounded-lg">
              <Lock className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <CardTitle className="text-xl text-amber-800">Two-Factor Authentication</CardTitle>
              <CardDescription>Add an extra layer of security with email verification</CardDescription>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Label className="text-amber-700">Enabled</Label>
            <Switch
              checked={settings.mfaEnabled}
              onCheckedChange={(checked) => setSettings({...settings, mfaEnabled: checked})}
            />
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {settings.mfaEnabled && (
          <div>
            <Label className="text-amber-800">Verification Email</Label>
            <div className="flex items-center gap-2 mt-1">
              <Mail className="w-4 h-4 text-amber-600" />
              <Input
                type="email"
                value={settings.mfaEmail}
                onChange={(e) => setSettings({...settings, mfaEmail: e.target.value})}
                placeholder="Enter email for verification codes"
                className="border-amber-200"
              />
            </div>
            <p className="text-xs text-gray-500 mt-2">
              A verification code will be sent to this email on each login attempt.
            </p>
          </div>
        )}
        
        {!settings.mfaEnabled && (
          <p className="text-gray-500 text-sm">
            Enable two-factor authentication to require a verification code sent to your email on each login.
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default MFATab;
